module.exports = __webpack_public_path__ + "static/media/1002143.ab43818c.png";